export function Header() {
  return `
    <header class="header">
      <a class="header__logo" href="/">
        <img src="/images/header-logo.png" alt="Forma Studio Logo">
      </a>
      <nav class="header__nav">
        <a href="https://calendar.app.google/1JjTCQx96w6tuZjq9" class="header__cta text-base font-semibold" target="_blank">Prenota una consulenza</a>
      </nav>
    </header>
  `;
} 